import http from "../requestBase";

const API_BASE = "api/UserSecurity";

// `api/UserSecurity/${this.editUserDialogData.userData.UserId}/LocationProperties`;

const LocationProperties = {
  /**
   * All LocationProperties of one Client and the permission of the Use
   * @param {string} ClientGuid the guid of the Client
   * @param {string} UserGuid the guid of the User
   * @returns - returns an Array
   */
  getforUser(ClientGuid, UserGuid) {
    return http.get(
      `${API_BASE}/${UserGuid}/LocationProperties/Client/${ClientGuid}`
    );
  },
  /**
   * Update the LocationProperties for a given User
   * @param {string} UserGuid the guid of the User
   * @param {object[]} data The Properties you want to update
   * @returns
   */
  updateforUser(UserGuid, data) {
    return http.put(`${API_BASE}/${UserGuid}/LocationProperties`, data);
  },

  /**
   *  Get list of propertie names which are not allowed for creation of new cx properties.
   */
  getCxProperties() {
    return http.get(`${API_BASE}/CxProperties`);
  },
};

// TODO: Add Locations,Project,etc
const UseUserSecurity = {
  LocationProperties,
};

export default UseUserSecurity;



// WEBPACK FOOTER //
// ./src/services/UserSecurity/index.js